import { type EditErrorCode, EditError } from '@repo/editor-core';
import { humanError } from '@/lib/api-error';

/**
 * 편집 실패를 사람이 읽는 한 줄로.
 *
 * 🔴 예전에는 `EditError.message` 를 토스트에 그대로 띄웠다. 그건 리듀서가 자기
 * 자신과 AI 에게 하는 말이라 영문에 내부 id 가 박혀 있다 — 실제로 클립을 겹치게
 * 끌면 사용자에게 이렇게 보였다(2026-09-11 시나리오 점검):
 *
 *     clip would overlap "clip-1" on track "video-1"
 *
 * `EditError` 는 `code` 를 들고 다니고 주석도 "UI 가 실행 가능한 메시지를 보여줄 수
 * 있게" 라고 적혀 있었는데, 정작 UI 가 그 코드를 안 쓰고 버렸다.
 *
 * `Record<EditErrorCode, string>` 이라 **코드를 추가하면 컴파일이 막힌다** — 문구를
 * 빼먹은 채 영문이 새어 나가는 일이 다시 생기지 않는다.
 */
const KO: Record<EditErrorCode, string> = {
  INVALID_COMMAND: '이 편집은 형식이 맞지 않아요.',
  ITEM_NOT_FOUND: '그 항목이 없어요. 화면을 새로 고쳐 주세요.',
  TRACK_NOT_FOUND: '그 트랙이 없어요. 화면을 새로 고쳐 주세요.',
  TRACK_KIND_MISMATCH: '그 줄에는 넣을 수 없는 항목이에요.',
  OVERLAP: '다른 클립과 겹쳐요. 빈 자리로 옮겨 주세요.',
  OUT_OF_BOUNDS: '클립 바깥은 자를 수 없어요.',
  INVALID_SOURCE_RANGE: '시작이 끝보다 뒤예요.',
  EMPTY_RESULT: '길이가 0이 돼요. 조금 더 남겨 주세요.',
  NOT_ADJACENT: '붙어 있는 두 클립 사이에만 넣을 수 있어요.',
};

/** 리듀서가 던진 것을 사용자에게 보여줄 문구로. 모르는 오류는 원문을 남긴다. */
export function editErrorMessage(e: unknown): string {
  if (e instanceof EditError) return KO[e.code] ?? e.message;
  // EditError 가 아닌 예외는 내부 원문(영문)이다 — 그대로 띄우지 않는다.
  return humanError(e, '편집을 적용하지 못했어요.');
}
